import { Box } from '@mui/material';
import { Link } from 'react-router-dom';

import logoSrc from '@/assets/branding/unbeatable-loans-logo.png';

type LogoProps = {
  /** Slightly larger sizing for footer placement */
  variant?: 'header' | 'footer';
};

export const Logo = ({ variant = 'header' }: LogoProps) => {
  const isFooter = variant === 'footer';
  return (
    <Link
      to="/"
      style={{ textDecoration: 'none', lineHeight: 0, display: 'inline-block' }}
    >
      <Box
        component="img"
        src={logoSrc}
        alt="Unbeatable Loans logo"
        loading="eager"
        decoding="async"
        width={1024}
        height={176}
        sx={{
          display: 'block',
          height: isFooter ? { xs: 44, sm: 52 } : { xs: 40, sm: 44 },
          width: 'auto',
          maxWidth: isFooter ? { xs: 300, sm: 360 } : { xs: 260, sm: 320 },
          flexShrink: 0,
          objectFit: 'contain',
          backfaceVisibility: 'hidden',
          transform: 'translateZ(0)',
        }}
      />
    </Link>
  );
};
